(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yuvenlife-ugc"] && !Shopify.designMode) return;
  try {
    (function(){
    function initUgc(){
      document.querySelectorAll('[data-ugc]').forEach(function(root){
        if(root.dataset.ugcReady)return;
        root.dataset.ugcReady='true';
        var track=root.querySelector('[data-ugc-track]');
        var prev=root.querySelector('[data-ugc-prev]');
        var next=root.querySelector('[data-ugc-next]');
        var videos=Array.from(root.querySelectorAll('[data-ugc-video]'));
        function update(){prev.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;}
        function move(direction){var card=track.querySelector('.ap-ugc__card');track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
        prev.addEventListener('click',function(){move(-1);});
        next.addEventListener('click',function(){move(1);});
        track.addEventListener('scroll',update,{passive:true});
        if('ResizeObserver' in window)new ResizeObserver(update).observe(track);
        root.querySelectorAll('[data-ugc-play]').forEach(function(button){
          var video=button.parentElement.querySelector('video');
          button.addEventListener('click',function(){
            if(!video.getAttribute('src')){video.src=video.dataset.src;video.load();}
            videos.forEach(function(other){if(other!==video)other.pause();});
            button.hidden=true;
            video.focus();
            var promise=video.play();
            if(promise)promise.catch(function(){button.hidden=false;});
          });
          video.addEventListener('play',function(){button.hidden=true;videos.forEach(function(other){if(other!==video)other.pause();});});
          video.addEventListener('ended',function(){button.hidden=false;});
          video.addEventListener('error',function(){button.hidden=false;});
        });
        if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(!entry.isIntersecting)entry.target.pause();});},{threshold:.1});videos.forEach(function(video){observer.observe(video);});}
        update();
      });
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initUgc);else initUgc();
    document.addEventListener('shopify:section:load',initUgc);
  }());
  } catch(e) { console.error(e); }
})();

})();
